import { c as _c } from "react/compiler-runtime";
import type { ColumnDef } from "@tanstack/react-table";
import { useEffect, useMemo, useState } from "react";
import { useWindowSize } from "usehooks-ts";
type ScreenSizes = "sm" | "md" | "lg";
interface ScreenSizeOpts {
  lg?: number;
  md?: number;
}
export type ResponsiveColumns<TData extends object> = (ColumnDef<TData> & {
  hideOn?: ScreenSizes[];
})[];
function useScreenSize(t0) {
  const {
    lg: t1,
    md: t2
  } = t0;
  const lg = t1 === undefined ? 1024 : t1;
  const md = t2 === undefined ? 768 : t2;
  const {
    width
  } = useWindowSize();
  if (!width) {
    return;
  }
  if (width > lg) {
    return "lg";
  }
  if (width > md) {
    return "md";
  }
  return "sm";
}

/**
 * This hook returns the correct columns for a given Screensize. Use the hideOn prop in your columnDefinition to
 * hide columns on the declared Screensizes
 * @param columnDef of the ResponsiveColumns<T> type
 * @param opts if you want to alter the breakpoints you can assign new ones to md and lg
 * @returns columns for the given Screensize
 */
export function useResponsiveColumns(columnDef, t0) {
  const $ = _c(9);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const opts = t1;
  const [mounted, setMounted] = useState(false);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setMounted(true);
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  const screenSize = useScreenSize(opts);
  let t4;
  bb0: {
    if (!(mounted && screenSize)) {
      t4 = columnDef;
      break bb0;
    }
    let t5;
    if ($[4] !== columnDef || $[5] !== screenSize) {
      let t6;
      if ($[7] !== screenSize) {
        t6 = col => !col.hideOn?.includes(screenSize);
        $[7] = screenSize;
        $[8] = t6;
      } else {
        t6 = $[8];
      }
      t5 = columnDef.filter(t6);
      $[4] = columnDef;
      $[5] = screenSize;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    t4 = t5;
  }
  const columns = t4;
  return columns;
}